/* Next */
import Head from 'next/head'

/* Types */
import { tProduct } from 'src/shared/frontendTypes/product'
import type { LandingPageImageAiGenerated } from 'src/functions/landingPageImageAiGenerated'

/* Components */
import Product from './Product'

/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

interface Props {
  product: tProduct
  recommendationsDeferred?: boolean
  initialVariantKey?: string
  landingPageImageAiGenerated?: LandingPageImageAiGenerated
}

const ProductPage: React.FC<Props> = ({ product, recommendationsDeferred, initialVariantKey, landingPageImageAiGenerated }:Props) => {
  return <>
    <Head>
      <title>{product.metaTitle}</title>
    </Head>
    <Product key={product.id} {...{ product, recommendationsDeferred, initialVariantKey, landingPageImageAiGenerated }} />
  </>

}

export default ProductPage
